var slider
document.addEventListener('DOMContentLoaded', function(){
  slider = new Swiper('.swiper', {
    speed: 600,
    loop: true
  });

});

// slideToメソッドでサムネイルと連動
function thumbnail(index, target) {
  
  const elems = document.querySelectorAll(".slider-thumbnail .swiper-slide");
  for(let elem of elems){
    elem.classList.remove("current");
  }

  target.classList.add("current");
  slider.slideTo(index);
}